import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "../../Componets/Header";
import Footer from "../../Componets/Footer";
import InquiryProduct from "../../Componets/InquiryProduct";
import productsData from "../../Data/productsData";

function Product1() {
  // const { slug } = useParams();

  // const product = productsData.find((p) => p.slug === slug);

  // const [changeImage, setChangeImage] = useState('');
  // const [showPopup, setShowPopup] = useState(false);
  // const [loading, setLoading] = useState(true);

  // Preloader timer
  // useEffect(() => {
  //   const timer = setTimeout(() => setLoading(false), 1000);
  //   return () => clearTimeout(timer);
  // }, []);
  // const formatSlug = (slug) => {
  //   if (!slug) return "";
  //   return slug
  //     .split("-")
  //     .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  //     .join(" ");
  // };
    const { slug } = useParams();

  const product = productsData.find((p) => p.slug === slug);

  const [changeImage, setChangeImage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(true);

  /* 🔹 Reset image when product / slug changes */
  useEffect(() => {
    if (product?.images?.main) {
      setChangeImage(product.images.main);
    }
  }, [slug, product]);

  /* 🔹 Loader */
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const formatSlug = (slug) => {
    if (!slug) return "";
    return slug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  if (!product) return null;
  return (
    <>
      {loading && (
        <div id="pre-load">
          <div id="loader" className="loader">
            <div className="loader-container">
              <div className="loader-icon">
                <img src="/assets/images/favicon.png" alt="Loader" />
              </div>
            </div>
          </div>
        </div>
      )}

      <Header />

      <Helmet>
        <title>{`Category | High-performance-endmills | ${formatSlug(slug)} | ${
          process.env.REACT_APP_COMPANYNAME
        } | ${process.env.REACT_APP_PHONE1}`}</title>
        <meta
          name="description"
          content="Explore our complete range of high-precision cutting tools including drills, endmills, ballnose endmills, and reamers for CNC & VMC machining."
        />

        <link
          rel="canonical"
          href={`${process.env.REACT_APP_SITE_URL}/product/${slug}`}
        />

        <meta
          property="og:url"
          content={`${process.env.REACT_APP_SITE_URL}/product/${slug}`}
        />

        <meta
          property="og:title"
          content={`Cutting Tools Products | ${process.env.REACT_APP_COMPANYNAME}`}
        />

        <meta
          property="og:description"
          content="Discover precision cutting tools manufactured for high performance CNC & VMC machining applications."
        />

        <meta property="og:type" content="website" />
      </Helmet>

      {/* Banner Section */}
      <section className="inner-page-banner">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/product">Our Product</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/high-performance-drills">
                      High Performance Drills
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">{product.name}</li>
                </ol>
              </nav>

              <div className="title text-white text-center">
                <h1 className="text-white product-heading">{product.name}</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRODUCT DETAILS */}
      <section className="product-dets-wrap d-flex gap-3 container">
        {/* LEFT IMAGE */}
        <div className="w-50 left-image">
          {/* <div className="h-25 bg-primary">
            <img src={changeImage} alt="product"/>
          </div> */}

          <div className="product-image-card">
            <img src={changeImage} alt="product" />
          </div>

          <div className="d-flex gap-3 justify-content-center mt-4">
            {product.images.thumbs.map((img, index) => (
              <div
                key={index}
                className="product-thumb-card"
                onClick={() => setChangeImage(img)}
              >
                <img src={img} alt="thumb" />
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT DETAILS */}
        <div className="product-dets d-flex flex-column">
          <h2 className="product-name-heading mb-4">{product.name}</h2>

          <button className="inquire-btn" onClick={() => setShowPopup(true)}>
            <span>INQUIRY VIA EMAIL</span>
            <i className="fa-regular fa-envelope"></i>
          </button>

          {showPopup && (
            <InquiryProduct
              onclose={() => setShowPopup(false)}
              productName={product.name}
            />
          )}

          {/* TABLE (UNCHANGED) */}
          <div className="product-details-text">
            {product?.tableGroups?.length > 0
              ? product.tableGroups.map((group, gIndex) => (
                  <div key={gIndex} className={`table-group ${group.style}`}>
                    <h3 className="group-title">{group.title}</h3>

                    {group.tables.map((table, tIndex) => (
                      <div key={tIndex} className="product-table-wrapper">
                        {/* <h4 className="table-subtitle">{table.subTitle}</h4> */}
                        {table.subTitle && (
                          <h4 className="table-subtitle">{table.subTitle}</h4>
                        )}

                        <table className={`product-table ${group.style}`}>
                          <thead>
                            <tr>
                              {table.headers.map((head, i) => (
                                <th key={i}>{head}</th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {table.rows.map((row, rIndex) => (
                              <tr key={rIndex}>
                                <td>{row.itemCode}</td>
                                <td>{row.millDia}</td>
                                <td>{row.shankDia}</td>
                                <td>{row.flute}</td>
                                <td>{row.oal}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ))}
                  </div>
                ))
              : product?.table && (
                  <table>
                    <thead>
                      <tr>
                        <td>ITEM CODE</td>
                        {product.table?.[0]?.angle && <td>ANGLE</td>}
                        <td>CUTTING DIA</td>
                        <td>SHANK DIA.</td>
                        <td>FLUTE</td>
                        <td>OAL</td>
                      </tr>
                    </thead>

                    <tbody>
                      {product.table.map((row, index) => (
                        <tr key={index}>
                          <td>{row.itemCode}</td>
                          {row.angle && <td>{row.angle}</td>}
                          <td>{row.cuttingDiameter}</td>
                          <td>{row.shankDiameter}</td>
                          <td>{row.fluteLength}</td>
                          <td>{row.overallLength}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
          </div>
        </div>
      </section>

      <Footer />

      {/* Back to top */}
      <div className="backtotop-wrap cursor-pointer has-theme-red">
        <svg
          className="backtotop-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </>
  );
}

export default Product1;
